var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    stroke: "#4F5260"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.833V10l4.167 1.667",
    stroke: "#4F5260",
    strokeLinecap: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMCAxNy41QzE0LjE0MjEgMTcuNSAxNy41IDE0LjE0MjEgMTcuNSAxMEMxNy41IDUuODU3ODYgMTQuMTQyMSAyLjUgMTAgMi41QzUuODU3ODYgMi41IDIuNSA1Ljg1Nzg2IDIuNSAxMEMyLjUgMTQuMTQyMSA1Ljg1Nzg2IDE3LjUgMTAgMTcuNVoiIHN0cm9rZT0iIzRGNTI2MCIvPgogICAgPHBhdGggZD0iTTEwIDUuODMzMzdWMTBMMTQuMTY2NyAxMS42NjY3IiBzdHJva2U9IiM0RjUyNjAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgTimeIcon as ReactComponent };